import { Component, Input } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-dynamic-content-outlet-error-component',
    template: `
    <div class="alert alert-danger">
      <div style="width: 25px; margin-right: 0.75rem">
        <svg [class]="'unity-icon unity-icon-xl unity-icon-error-fill'">
          <use xlink:href="#unity-icon-error-fill"></use>
        </svg>
      </div>
      <div>
        <div>
          {{ message }}
        </div>
        <div class="mt-1">{{ errorMessage }}</div>
      </div>
    </div>
  `
})
export class DynamicContentOutletErrorComponent {
    @Input() errorMessage: string;

    message: string;
    constructor() {
        this.message = `Component Load Failed.  Ensure component is registered in dynamic-content-outlet.registry
    and module has been registered in dynamic-content-module-loader.registry with a correct loadChildren function.`;
    }
}
